import { SortDirection } from '@capital-access/common/utils';
import { HistoricalOwnershipReportFilters } from '@capital-access/reporting/common';
import { BaseReportRequest } from '../../core/models/report-request.models';
import { ReportSection } from '../../core/models/report-sections';

export interface CreateHistoricalOwnershipRequest extends BaseReportRequest {
  sections: ReportSection[];
  reportedQuarters: string[];
  filters?: HistoricalOwnershipReportFilters;
  includeTables: boolean;
  sortDirection?: SortDirection;
  displayCurrentBreakdown: boolean;
}

export class CreateHistoricalOwnershipDto {
  reportedQuarters: string[];
  filters?: HistoricalOwnershipReportFilters;
  sortDirection?: SortDirection;
  displayCurrentBreakdown: boolean;

  constructor(
    reportedQuarters: string[],
    displayCurrentBreakdown: boolean,
    filters?: HistoricalOwnershipReportFilters,
    sortDirection?: SortDirection
  ) {
    this.reportedQuarters = reportedQuarters;
    this.filters = filters;
    this.sortDirection = sortDirection;
    this.displayCurrentBreakdown = displayCurrentBreakdown;
  }

  static create(
    reportedQuarters: string[],
    displayCurrentBreakdown: boolean,
    filters?: HistoricalOwnershipReportFilters,
    sortDirection?: SortDirection
  ): CreateHistoricalOwnershipDto {
    return new CreateHistoricalOwnershipDto(reportedQuarters, displayCurrentBreakdown, filters, sortDirection);
  }
}
